/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Une entrée de errorDetails : la clé (traduisible) et le contexte (colonne, valeur) d'un échec.
 */
export interface ImportLineDtoErrorDetail {
    key?: string;
    fieldSrc?: string;
    fieldDest?: string;
    data?: string;
}
